import type * as React from 'react';
import { cn } from '../lib/cn.js';

/** Gabarit de page unique du produit : marges et rythme vertical de tous les écrans. */
export function PageContainer({ className, children, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'w-full max-w-full min-w-0 px-3 sm:px-5 md:px-7 py-3 sm:py-5 md:py-7 space-y-3 sm:space-y-5 md:space-y-7',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
